import { RecordContext, TextField } from "react-admin";
import { Avatar, Box, Tooltip, Typography, useTheme } from "@mui/material";
import Board from "../../misc/Board";
import { Student } from "../../providers/studentsProvider";
import { EuroIcon } from "../../icons/EuroIcon";
import { Money } from "../../misc/Money";
import { ClockIcon } from "../../icons/ClockIcon";
import { DrivingSchoolLogo } from "../../misc/DrivingSchoolLogo";
import { DrivingSchool } from "../../providers/drivingSchoolsProvider";
import { useLocation } from "react-router-dom";

interface DunningCardProps {
  student: Student & { lastStepDuration: number | null };
  drivingSchool?: DrivingSchool;
  onClick?: (student: Student) => void;
}
export const DunningCard = ({ student, drivingSchool, onClick }: DunningCardProps) => {
  const { pathname } = useLocation();
  const theme = useTheme();
  const showDrivingSchool = pathname === "/dunning";

  const outstandingAmount =
    student.dunningProcess?.outstandingAmount ?? (student.balance < 0 ? Math.abs(student.balance) : null);

  return (
    <Board.Card
      onClick={() => {
        onClick?.(student);
      }}
    >
      <RecordContext.Provider value={student}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "16px 1fr",
            gridTemplateRows: "auto auto auto",
            gap: "5px",
            alignItems: "center",
          }}
        >
          <Box mt="2px">
            <Avatar alt={student.name} src={student.avatarUrl} sx={{ width: "16px", height: "16px" }} />
          </Box>
          <TextField
            source="name"
            variant="body2"
            sx={{ fontWeight: 600, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
          />
          {showDrivingSchool && (
            <>
              <Box sx={{ width: "16px", height: "16px", borderRadius: "50%", overflow: "hidden" }}>
                <DrivingSchoolLogo drivingSchool={drivingSchool} size={16} />
              </Box>
              <Tooltip title={drivingSchool?.name ?? null}>
                <Box
                  sx={{
                    color: "text.secondary",
                    fontSize: "12px",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  {drivingSchool?.name}
                </Box>
              </Tooltip>
            </>
          )}
          {outstandingAmount && (
            <>
              <EuroIcon
                fontSize="inherit"
                sx={{ width: 16, height: 16, color: "text.secondary" }}
                viewBox="0 0 16 16"
              />
              <Money cents={outstandingAmount} style={{ color: theme.palette.text.secondary, fontSize: "12px" }} />
            </>
          )}
          <StudentLastStepDuration lastStepDuration={student.lastStepDuration} />
        </Box>
      </RecordContext.Provider>
    </Board.Card>
  );
};

const StudentLastStepDuration = ({ lastStepDuration }: { lastStepDuration: number | null }) => {
  if (lastStepDuration === null) {
    return null;
  }
  return (
    <>
      <ClockIcon fontSize="inherit" sx={{ width: 16, height: 16, color: "text.secondary" }} viewBox="0 0 16 16" />
      <Typography variant="body2" sx={{ color: "text.secondary", fontSize: "12px" }}>
        {lastStepDuration} {lastStepDuration === 1 ? "Tag" : "Tage"}
      </Typography>
    </>
  );
};
